/* VitaWoof purchase sheet (vw2). The buy box lives in a fixed bottom drawer that the
   sticky "Jetzt kaufen" bar opens. Money path untouched: the drawer only wraps the
   existing product form. Close signals: X, backdrop, Esc, and a SUCCESSFUL add to
   cart (cart:update with source 'product-form-component' and didError !== true; the
   error path fires the same event name with didError: true and must keep the sheet
   open so the inline error stays visible). Horizon opens no cart drawer on mobile,
   so the sticky button flashes a short confirmation after a successful add. */
(function () {
  var sheet = null;
  var panel = null;
  var lastFocus = null;
  var flashTimer = null;

  function q(sel, root) { return (root || document).querySelector(sel); }

  function isOpen() { return !!sheet && sheet.classList.contains('is-open'); }

  function focusables() {
    var sel = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(panel.querySelectorAll(sel), function (n) {
      return n.offsetWidth || n.offsetHeight || n.getClientRects().length;
    });
  }

  function open(trigger) {
    if (!sheet || isOpen()) return;
    lastFocus = trigger || document.activeElement;
    sheet.classList.add('is-open');
    sheet.removeAttribute('aria-hidden');
    document.documentElement.classList.add('vw2-sheet-lock');
    var first = q('[data-vw2-sheet-close]', panel) || panel;
    try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
  }

  function close() {
    if (!isOpen()) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vw2-sheet-lock');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); }
    }
    lastFocus = null;
  }

  function doseModalOpen() {
    var dose = q('[data-vw-dose-modal]');
    return !!(dose && !dose.hidden);
  }

  function flashSticky() {
    var btn = q('[data-vw2-sheet-open] .vw2-buynow__btn-label') || q('[data-vw2-sheet-open]');
    if (!btn) return;
    if (!btn.__vw2Idle) btn.__vw2Idle = btn.textContent;
    btn.textContent = 'Im Warenkorb';
    clearTimeout(flashTimer);
    flashTimer = setTimeout(function () { btn.textContent = btn.__vw2Idle; }, 2000);
  }

  function syncLabelFromDom() {
    var label = q('[data-vw2-buynow-price]');
    var abo = q('vw-pdp-abo');
    if (label && abo && abo.dataset.label) label.textContent = abo.dataset.label;
  }

  function initSwipeToClose() {
    var body = q('[data-vw2-sheet-body]', panel);
    var grab = q('[data-vw2-sheet-grab]', panel);
    var head = q('[data-vw2-sheet-head]', panel);
    var DRAG_THRESHOLD = 8; // px of vertical movement before a touch counts as a drag, not a tap
    var CLOSE_RATIO = 0.25; // close once dragged past 25% of the panel's height
    var CLOSE_VELOCITY = 0.5; // or close on a fast flick, in px/ms, even if short
    var startY = 0, startT = 0, lastY = 0, lastT = 0, tracking = false, dragging = false;

    function onStart(e) {
      if (!isOpen() || doseModalOpen()) return;
      // A touch starting inside the scrollable body only begins a close-drag when
      // already scrolled to the top; otherwise let the body scroll normally.
      if (body && body.contains(e.target) && body.scrollTop > 0) return;
      var t = e.touches[0];
      startY = lastY = t.clientY;
      startT = lastT = e.timeStamp;
      tracking = true;
      dragging = false;
    }

    function onMove(e) {
      if (!tracking) return;
      var t = e.touches[0];
      var dy = t.clientY - startY;
      if (!dragging) {
        if (dy < DRAG_THRESHOLD) { lastY = t.clientY; lastT = e.timeStamp; return; }
        dragging = true;
        panel.style.transition = 'none';
      }
      if (dy < 0) dy = 0;
      e.preventDefault();
      panel.style.transform = 'translateY(' + dy + 'px)';
      lastY = t.clientY;
      lastT = e.timeStamp;
    }

    function onEnd() {
      tracking = false;
      if (!dragging) return;
      dragging = false;
      var dy = lastY - startY;
      if (dy < 0) dy = 0;
      var velocity = dy / Math.max(1, lastT - startT);
      var shouldClose = dy > panel.offsetHeight * CLOSE_RATIO || velocity > CLOSE_VELOCITY;
      panel.style.transition = '';
      panel.style.transform = '';
      if (shouldClose) close();
    }

    [grab, head, body].forEach(function (el) {
      if (el) el.addEventListener('touchstart', onStart, { passive: true });
    });
    panel.addEventListener('touchmove', onMove, { passive: false });
    panel.addEventListener('touchend', onEnd);
    panel.addEventListener('touchcancel', onEnd);
  }

  function init() {
    sheet = q('[data-vw2-sheet]');
    if (!sheet || sheet.__vw2SheetInit) return;
    sheet.__vw2SheetInit = true;
    panel = q('[data-vw2-sheet-panel]', sheet);
    if (!panel) return;

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-vw2-sheet-open]');
      if (opener) { e.preventDefault(); open(opener); return; }
      if (e.target.closest('[data-vw2-sheet-close]')) { e.preventDefault(); close(); return; }
      if (isOpen() && e.target.hasAttribute && e.target.hasAttribute('data-vw2-sheet-backdrop')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!isOpen() || doseModalOpen()) return;
      // defaultPrevented = a layer above (the dose modal's capture handler in the
      // protected controller) already consumed this Esc; do not double-close.
      if (e.key === 'Escape') { if (e.defaultPrevented) return; e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) { e.preventDefault(); return; }
        var first = f[0];
        var last = f[f.length - 1];
        var active = document.activeElement;
        if (e.shiftKey && (active === first || !panel.contains(active))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (active === last || !panel.contains(active))) { e.preventDefault(); first.focus(); }
      }
    });

    document.addEventListener('cart:update', function (e) {
      var d = e.detail && e.detail.data;
      if (!d || d.source !== 'product-form-component' || d.didError === true) return;
      close();
      flashSticky();
    });

    document.addEventListener('vw:plan-change', function (e) {
      var label = q('[data-vw2-buynow-price]');
      if (label && e.detail && e.detail.text) label.textContent = e.detail.text;
    });

    // vw-pdp-abo (a module) commits its initial state before this deferred script
    // attaches the listener above, so read the label it already wrote to the DOM.
    syncLabelFromDom();

    initSwipeToClose();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
